// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
import Viser from 'viser-vue'
import store from './store'
import PouchDB from 'pouchdb'
import VueCookie from 'vue-cookie'
import CKEditor from 'ckeditor4-vue'
import InputColorPicker from 'vue-native-color-picker'

// import VueDraggable from 'vue-draggable'

/**
 * VUE GLOBAL FILTERS
 */
import '@/filters/filters'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import '@/permissionControl/permission' // permission control

/**
 * USED PLUGINS
 */
Vue.use(Viser)
Vue.use(Antd)
Vue.use(VueCookie)
Vue.use(CKEditor)
Vue.use(InputColorPicker)

Vue.component('v-select', vSelect)

Vue.config.productionTip = false
Vue.config.devtools = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    var db = new PouchDB('admindb')
    db.get('currUser')
      .then((doc) => {
        this.$store.commit('Account/SET_USER', doc.user)
      })
      .catch((error) => {
        console.error('User Logout', error)
      })
  }
})



// WEBPACK FOOTER //
// ./src/main.js